import { applyMiddleware, combineReducers, compose,createStore,} from 'redux';
import { thunk } from 'redux-thunk';
import { AuthReducer } from './reducers/AuthReducer';

const logger = store => next => action => {
  return next(action);
};
const middleware = applyMiddleware(thunk, logger);

const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const reducers = combineReducers({
    auth: AuthReducer,
});

//const store = createStore(rootReducers);

export const store = createStore(reducers,  composeEnhancers(middleware));
